<template>
  <div v-if="drawComponent">
    <div class="row" v-if="showForm">
      <div v-if='id'>
        <div class="col-sm-6">
          <panel :title='object.name'>
            <div slot="headingElements">
              <div class="pull-right">
                <button v-if="mode.readonly" @click.prevent="() => { mode.readonly = false }" class="btn btn-primary btn-ladda">EDIT AGENCY DATA</button>
                <template v-else-if="!mode.readonly">
                  <button @click.prevent="saveData()" class="btn btn-primary btn-ladda mr-10">SAVE DATA</button>
                  <button @click.prevent="() => { mode.readonly = true }" class="btn btn-default btn-ladda mr-10">CANCEL</button>
                </template>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-9">
                <div class="row">
                  <div class="col-sm-8">
                    <div class="form-group" :class="{'has-error': errors.has('location') }">
                      <label class="control-label">Name</label>
                      <input type="text" v-model="object.name" :readonly="mode.readonly" class="form-control"/>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group" :class="{'has-error': errors.has('computedSum') }">
                      <label class="control-label">City</label>
                      <input type="text" v-model="object.city" :readonly="mode.readonly" class="form-control"/>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-8">
                    <div class="form-group" :class="{'has-error': errors.has('budget') }">
                      <label class="control-label">Address</label>
                      <input type="text" v-model="object.address" :readonly="mode.readonly" class="form-control"/>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group" :class="{'has-error': errors.has('computedSum') }">
                      <label class="control-label">ZIP code</label>
                      <input type="text" v-model="object.zip" :readonly="mode.readonly" class="form-control"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group lessdzheight">
                  <label class="control-label">Logo</label>
                  <div class="thumbnail" style="margin-top: 0;" v-if="object.logo">
                    <div class="thumb">
                      <a class="logo-image" :href="object.logo.fullscale" data-popup="lightbox">
                        <img v-if="object.logo.is_public" :src="object.logo.preview" alt="logo" style="object-position: 50% 50%"/>
                        <img v-if="!object.logo.is_public" v-auth-img="object.logo.preview" style="object-position: 50% 50%" alt="logo"/>
                      </a>
                      <div class="caption-overflow">
                        <span>
                          <a href="javascript: void(0);" class="btn btn-info btn-sm" @click="removeLogo()">Remove</a>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <UploadForm :dropzone="true" accept="image/*" @uploadComplete="uploadComplete" @uploadError="uploadError"></UploadForm>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-5">
                <div class="form-group" :class="{'has-error': errors.has('budget') }">
                  <label class="control-label">Country</label>
                  <input type="text" v-model="object.country" :readonly="mode.readonly" class="form-control"/>
                </div>
              </div>
              <div class="col-sm-7">
                <div class="form-group" :class="{'has-error': errors.has('budget') }">
                  <label class="control-label">Region</label>
                  <input type="text" v-model="object.region" :readonly="mode.readonly" class="form-control"/>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-5">
                <div class="form-group" :class="{'has-error': errors.has('location') }">
                  <label class="control-label">Director name</label>
                  <input type="text" v-model="object.director_name" :readonly="mode.readonly" class="form-control"/>
                </div>
              </div>
              <div class="col-sm-7">
                <div class="form-group" :class="{'has-error': errors.has('budget') }">
                  <label class="control-label">Email</label>
                  <input type="text" v-model="object.email" :readonly="mode.readonly" class="form-control"/>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-5">
                <div class="form-group" :class="{'has-error': errors.has('computedSum') }">
                  <label class="control-label">Phone</label>
                  <input type="text" v-model="object.phone" :readonly="mode.readonly" class="form-control"/>
                </div>
              </div>
              <div class="col-sm-7">
                <div class="form-group" :class="{'has-error': errors.has('computedSum') }">
                  <label class="control-label">Website URL</label>
                  <input type="text" v-model="object.website_url" :readonly="mode.readonly" class="form-control"/>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group" :class="{'has-error': errors.has('computedSum') }">
                  <label class="control-label">Notes</label>
                  <textarea :rows="4" v-model="object.notes" :readonly="mode.readonly" class="form-control"/>
                </div>
              </div>
            </div>
            <hr class="hr-condensed"/>
            <div class="row">
              <agency-agent-form @item:added="refreshAgents" :parent="object"></agency-agent-form>
            </div>
          </panel>
        </div>
        <div class="col-sm-6">
          <panel :title="'Agents'">
            <agency-agents @item:deleted="refreshAgents" @item:changed="refreshAgents" :parent="object" :items="agents"></agency-agents>
          </panel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import AgencyService from '@/services/agency.service'

import Panel from '@/components/_partial/_atomic/panel'
import UploadForm from '../_partial/UploadForm'
import AgencyAgentForm from './_partial/AgencyAgentForm'
import AgencyAgents from './_partial/AgencyAgents'

export default {
  name: 'AgencyDetails',
  components: {
    UploadForm,
    AgencyAgentForm,
    AgencyAgents,
    Panel
  },

  props: ['entity', 'oid'],
  data () {
    return {
      id: null,
      object: {},
      agents: [],
      idFilter: [],
      currentObject: false,
      localizedFormat: {},
      /** service **/
      service: AgencyService,
      statuses: [],
      systemStatuses: [],
      showForm: false,
      mode: {
        statusMap: {},
        resetAfterMount: false,
        readonly: true
      },
      /** **/
      objectState: {},
      /** **/
      groupEditMode: false,
      groupViewMode: false,
      groupAddMode: false,
      /** **/
      hasChanges: false,
      savingChanges: false,
      drawComponent: true,
      /** **/
      uploadUrl: ''
    }
  },

  computed: {},

  beforeMount () {
    this.localizedFormat = Vue.config.localizedFormat
    if (this.mode.resetAfterMount) {
      this.reset(true)
    }
    this.mode.statusMap = Vue.config.statusMap
    this.systemStatuses = Vue.config.statuses
    this.statuses = []
  },

  watch: {
    '$route': 'flushObjectIfRequired'
  },

  mounted () {
    // let promises = []
    this.reset(true)
    this.refresh()
    this.mode.resetAfterMount = false
  },

  methods: {
    flushObjectIfRequired () {
      console.log(this.$route)
      if (this.$route.name === 'agency.create') {
        this.id = false
        this.mode.resetAfterMount = true
        // this.object = {}
        for (let i in this.service.__itemTemplate) {
          this.object[i] = this.service.__itemTemplate[i]
        }
        this.$emit('resetObject', this.object)
        this.mode.resetAfterMount = false
        this.hardReset()
      } else {
        if (this.oid) {
          this.service.item(this.oid, result => {
            for (let i in result) {
              if (result.hasOwnProperty(i)) {
                this.object[i] = result[i]
              }
            }
            this.id = this.object.id
            this.$emit('loadObject', this.object)
            this.showForm = true
            this.$emit('shown', this.object)
            this.hardReset()
            this.uploadUrl = Vue.config.endpoints.agency.attachImages.replace('{:id}', this.id)
          })
        }
      }
    },

    hardReset () {
      let vm = this
      vm.drawComponent = false
      Vue.nextTick(() => {
        vm.drawComponent = true
        this.makeIdFilter()
        this.object = this.object
      })
    },

    reset (forceItemReset = true) {
      this.hasChanges = false
      if (typeof this.entity === 'object' && this.entity.hasOwnProperty('id')) {
        for (let i in this.entity) {
          if (this.entity.hasOwnProperty(i)) {
            this.object[i] = this.entity[i]
            if (i === 'required_at') {
              this.object.period = this.$moment(this.object[i]).format(Vue.config.localizedFormat.date)
            }
          }
        }
        this.id = this.entity.id
        forceItemReset = false
      }
      this.$emit('reset', forceItemReset)
      if (forceItemReset) {
        this.flushObjectIfRequired()
        this.$emit('resetObject', this.object)
        this.mode.resetAfterMount = false
      }
      if (this.object.hasOwnProperty('id')) {
        this.id = this.object.id
        this.uploadUrl = Vue.config.endpoints.agency.attachImages.replace('{:id}', this.id)
      }
      this.makeIdFilter()
    },

    refresh (newInstance) {
      if (!this.object.id && this.oid) {
        this.service.item(this.oid, result => {
          for (let i in result) {
            if (result.hasOwnProperty(i)) {
              this.object[i] = result[i]
            }
          }
          this.id = this.object.id
          this.uploadUrl = Vue.config.endpoints.agency.attachImages.replace('{:id}', this.id)
          this.$emit('loadObject', this.object)
          this.showForm = true
          this.$emit('shown', this.object)
          this.refreshAgents()
          this.hardReset()
        })
      } else {
        if (newInstance) {
          for (let i in newInstance) {
            if (newInstance.hasOwnProperty(i)) {
              this.object[i] = newInstance[i]
            }
          }
          this.id = this.object.id
          this.uploadUrl = Vue.config.endpoints.agency.attachImages.replace('{:id}', this.id)
          this.$emit('assignObject', this.object)
          this.showForm = true
          this.$emit('shown', this.object)
          this.refreshAgents()
          this.hardReset()
        }
        this.showForm = true
        this.$emit('shown', this.object)
      }
      if (this.object.hasOwnProperty('id')) {
        this.id = this.object.id
      }
      this.makeIdFilter()
    },

    refreshAgents () {
      let roleFilter = null
      if (this._is('superAdmin') || this._is('agencyAdmin')) {
        roleFilter = ['agencyAgent', 'agencyAdmin', 'agencyUnlicensedAgent']
      }
      this.service.getAgents(this.object.id, { role: roleFilter }, result => {
        this.agents = result
      })
    },

    setItemStatus (item, status) {
      this.service.update(item, {
        'id': item,
        'status': status
      }, result => {
        this.service.item(result.id).then(newdata => {
          this.refresh(newdata)
          this.hasChanges = true
          this.hasChanges = false
        })
      }, () => {
        this.$popup.warning('Can\'t set item STATUS on server')
      })
    },

    saveData () {
      if (this.id) {
        this.service.update(this.id, this.prepareData(this.object), result => {
          if (!this.mode.readonly) {
            this.mode.readonly = true
          }
          this.refresh()
        })
      }
    },

    enterEditMode () {
      this.mode.readonly = false
      this.showForm = false
      this.showForm = true

      this.objectState = Object.assign({}, this.object)
    },

    cancelEditMode () {
      this.mode.readonly = true
      this.showForm = false
      this.showForm = true

      this.object = this.objectState
      this.$forceUpdate()
    },

    saveChanges () {
      if (this.hasChanges) {
      }
    },

    checkChanges (e) {
      this.hasChanges = true
    },

    prepareData (obj) {
      let result = Object.assign({}, obj)
      return result
    },

    prepareImageData (obj) {
      let result = Object.assign({}, { logo_image_id: obj.logo_image_id })
      return result
    },

    canBeChanged () {
      let result = typeof this.object === 'object'
      result = result && this.object.status === 1
      return result
    },

    changePublicAgency (event) {
      this.object.is_public = event.value
    },

    /** invoice can be **/

    /** **/

    formatPrice (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    makeIdFilter () {
      this.idFilter = []
    },

    /** action methods **/
    setLogo (image) {
      this.object = Object.assign(this.object, {
        logo: image || null
      })
      this.object.logo_image_id = image.id || null
      this.service.update(this.id, this.prepareImageData(this.object), () => {
        this.object.id = null
        this.refresh()
      }, () => {
        this.$popup.error('Cannot set agency logo', 'Error')
      })
    },

    removeLogo () {
      this.object.logo = null
      this.object.logo_image_id = null
      this.service.update(this.id, this.prepareImageData(this.object), () => {
        this.object.id = null
        this.refresh()
      }, () => {
        this.$popup.error('Cannot remove agency logo', 'Error')
        this.$forceUpdate()
      })
    },

    uploadComplete (file) {
      this.$logger.log('uploadComplete', file)
      this.setLogo(file.uploaded.image || null)
    },

    uploadError (file) {
      this.$logger.log('uploadError', file)
      this.$popup.warning('Failed to upload file')
    }

    /** sub-action methods **/
  },
  beforeDestroy () {
    this.object = {}
  }
}
</script>

<style scoped>
.logo-image img {
  max-height: 112px;
  min-height: 112px;
  max-width: 100%;
  width: auto;
}
</style>
